var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResult24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5967 2.75C19.6477 2.75 20.5 3.55951 20.5 4.55762V20.9424C20.5 21.9405 19.6477 22.75 18.5967 22.75H5.40332C4.35233 22.75 3.5 21.9405 3.5 20.9424V4.55762C3.5 3.55951 4.35233 2.75 5.40332 2.75H8V3.75C8 3.99157 8.04555 4.22214 8.12402 4.43652H5.40332C5.33325 4.43652 5.27637 4.49108 5.27637 4.55762V20.9424C5.27637 21.0089 5.33325 21.0635 5.40332 21.0635H18.5967C18.6667 21.0635 18.7236 21.0089 18.7236 20.9424V4.55762C18.7236 4.49108 18.6667 4.43652 18.5967 4.43652H15.876C15.9545 4.22214 16 3.99157 16 3.75V2.75H18.5967Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3179 3.62323L9.59319 3.13292L8.66948 4.49823H10.3179V3.62323ZM13.6821 3.62323V4.49823H15.3305L14.4068 3.13292L13.6821 3.62323ZM8 3.62323V2.74823H7.125V3.62323H8ZM9.19286 3.62323V4.49823H9.79013L10.0077 3.942L9.19286 3.62323ZM16 3.62323H16.875V2.74823H16V3.62323ZM14.8071 3.62323L13.9923 3.942L14.2099 4.49823H14.8071V3.62323ZM10.3179 3.62323V4.49823H13.6821V3.62323V2.74823H10.3179V3.62323ZM13.6821 3.62323L14.4068 3.13292C13.8929 2.37335 13.008 1.875 12 1.875V2.75V3.625C12.4217 3.625 12.7659 3.83056 12.9574 4.11354L13.6821 3.62323ZM12 2.75V1.875C10.992 1.875 10.1071 2.37335 9.59319 3.13292L10.3179 3.62323L11.0426 4.11354C11.2341 3.83056 11.5783 3.625 12 3.625V2.75ZM8 3.62323V4.49823H9.19286V3.62323V2.74823H8V3.62323ZM8 5.6H8.875V3.62323H8H7.125V5.6H8ZM10 7.6V6.725C9.37868 6.725 8.875 6.22132 8.875 5.6H8H7.125C7.125 7.18782 8.41218 8.475 10 8.475V7.6ZM14 7.6V6.725H10V7.6V8.475H14V7.6ZM16 5.6H15.125C15.125 6.22132 14.6213 6.725 14 6.725V7.6V8.475C15.5878 8.475 16.875 7.18782 16.875 5.6H16ZM16 3.62323H15.125V5.6H16H16.875V3.62323H16ZM14.8071 3.62323V4.49823H16V3.62323V2.74823H14.8071V3.62323ZM12 1.75V2.625C12.917 2.625 13.6946 3.18099 13.9923 3.942L14.8071 3.62323L15.622 3.30446C15.0571 1.86029 13.6243 0.875 12 0.875V1.75ZM9.19286 3.62323L10.0077 3.942C10.3054 3.18099 11.083 2.625 12 2.625V1.75V0.875C10.3757 0.875 8.94295 1.8603 8.37799 3.30446L9.19286 3.62323Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.625,
    cy: 12.1943,
    r: 0.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.625,
    cy: 17.2251,
    r: 0.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.625,
    cy: 14.7749,
    r: 0.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.25H15.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.75H15.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.25H15.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult24Px);
export default __webpack_public_path__ + "static/media/result_24px.a38ce8823b71433167948e3d0dd1221a.svg";
export { ForwardRef as ReactComponent };